import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { FormikProps } from "formik";
import React, { useEffect, useState } from "react";
import {
  getStripeKeys,
  getStripePaymentIntent,
} from "../../apis/payment/stripe";
import { IDocsDriver } from "../../utils/types";
import CheckoutForm from "./CheckoutForm";
import { MainFormType } from "./CreateServiceModal";
import DriversTable from "./DriversTable";
import Button from "../Button";
import { getDriver } from "../../apis/services/create-service";
import { toast } from "react-toastify";

interface PaymentProps {
  form: FormikProps<MainFormType>;
}

const Payment = ({ form }: PaymentProps) => {
  const [stripe, setStripe] = useState<Promise<Stripe | null> | null>(null);
  const [paymentIntent, setPaymentIntent] = useState<string | null>(null);
  const [amount, setAmount] = useState(0);
  const isDeliveriesAvailable = Number(form?.values?.recipientDetails?.isDeliveriesAvailable)
  const [isSelectingDriver, setIsSelectingDriver] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSelectDriver = (driver: IDocsDriver | null) => {
    form.setFieldValue("driver", driver);
  };

  const placeOrder = async () => {
    setIsSubmitting(true);

    const driverFound = await getDriver({
      assignedDriverId: form.values.driver?._id!,
      scheduleTime: form.values.scheduleTime
        ? form.values.scheduleTime.toISOString()
        : null,
    });

    if (!driverFound?.success) {
      toast.error(driverFound?.error?.error || "Driver is currently unavailable");
      setIsSubmitting(false);
      return;
    }
    setIsSubmitting(false)
    await form.handleSubmit();

  };


  useEffect(() => {
    if (!isDeliveriesAvailable) {
      const handleGetStripeKeys = async () => {
        const res = await getStripeKeys();
        if (res?.success) {
          setStripe(loadStripe(res?.data?.STRIPE_PUBLISHABLE_KEY!));
        }
      };
      const handleGetPaymentIntent = async () => {
        const res = await getStripePaymentIntent({
          userId: form.values.user?._id!,
          amount: Number(form.values.serviceCost?.discountedUserTotal!),
        });
        if (res?.success) {
          setPaymentIntent(res?.data?.client_secret);
          setAmount(Number(res?.data?.amount) / 100);
        }
        console.log(res, "payment intent res");
      };
      handleGetStripeKeys();
      handleGetPaymentIntent();
    }

  }, []);

  return (
    <>
      <div className="flex flex-col gap-4">

        {!isDeliveriesAvailable && <p className="text-lg font-semibold text-center">Driver & payment</p>}
        <div className="flex w-full flex-col">
          <p className="font-semibold">Driver *</p>
          <button
            type="button"
            onClick={() => setIsSelectingDriver(true)}
            className="flex h-14 items-center gap-4 border mt-4 border-primary rounded-lg px-4 py-2"
          >
            {form.values.driver && (
              <img
                className="w-10 h-10 rounded-full"
                src={form.values.driver.profileImage}
                alt="driver"
              />
            )}
            <p>
              {form.values.driver
                ? form.values.driver.fullName
                : "Please select a driver"}
            </p>
          </button>
          {form.errors.driver && (
            <div className="label">
              <span className="label-text-alt text-red-600">
                {form.errors.driver}
              </span>
            </div>
          )}
        </div>
        {stripe && paymentIntent && !isDeliveriesAvailable && (
          <Elements stripe={stripe} options={{ clientSecret: paymentIntent }}>
            <p className="font-semibold">Payment *</p>
            <CheckoutForm
              scheduleTime={form.values.scheduleTime}
              driverId={form.values.driver?._id!}
              amount={amount.toString()}
              isDriverSelected={form.values.driver !== null}
              isSubmittingForm={form.isSubmitting}
              onSuccessfullPayment={(id: string) => {
                form.setFieldValue("paymentIntent", id);
                form.handleSubmit();
              }}
            />
          </Elements>
        )}
        {isDeliveriesAvailable ? <div className="w-full flex justify-center">
          <Button
            isLoading={isSubmitting || form?.isSubmitting}
            className="w-full md:w-32 min-h-0 h-10 md:h-10"
            onClick={placeOrder}
          >
            Place order
          </Button>
        </div> : ""}

      </div>
      <DriversTable
        selectedDriver={form.values.driver}
        onSelectDriver={handleSelectDriver}
        isVisible={isSelectingDriver}
        onHide={() => setIsSelectingDriver(false)}
      />
    </>
  );
};

export default Payment;
